var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "비대면 면접",
      "topBtn": "",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('interview-view', {
    attrs: {
      "mode": "view"
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }